//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';

// TODO: PD-312744 Remove this once the feature is ready
export const getIsSamplingContentDestinationsEnabled = createHasFeatureSelector(
  FeatureNames.SamplingContentDestinations,
);
